import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Container, Navbar, Nav, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import HHlogo from '../HHlogo.png';
import scienceImage from '../images/science.jpeg';
import primary from '../images/primary.jpeg';
import primaryS from '../images/primaryS.jpeg';
import high from '../images/high.jpeg';
import '../main.css';
import MainHomeNav from './MainHomeNav';

const MainHome = () => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  const bgColor = '#3e74bbff';

  const handleContactClick = () => {
    navigate('high-school/contact');
  };

  return (
    <div style={{ backgroundColor: bgColor, color: 'white', minHeight: '100vh' }}>
      {/* Navbar */}
      <Navbar expand="lg" expanded={expanded} className="custom-navbar" variant="dark" style={{ backgroundColor: bgColor }}>
        <Container>

<Navbar.Brand as={Link} to="/" className="d-flex flex-column align-items-start">
  <div className="d-flex align-items-center">
    <img
      src={HHlogo}
      alt="HHL Logo"
      className="navbar-logo d-inline-block align-top me-2"
      style={{ cursor: 'pointer' }}
    />
    <div>
      <div className="fw-bold">HIGHLANDS</div>
      <div style={{ fontSize: '0.9rem', fontFamily: '"Arial Narrow", sans-serif', fontWeight: 'normal' }}>
        EMIS NO: 996602113
      </div>
  </div>
  </div>
</Navbar.Brand>


          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            className={`custom-toggler ${expanded ? 'open' : ''}`}
          >
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavLink to="/primary-school" className="nav-link">PRIMARY SCHOOL</NavLink>
              <NavLink to="/high-school" className="nav-link">HIGH SCHOOL</NavLink>
              <NavLink to="/admission" className="nav-link">ADMISSIONS</NavLink>
            </Nav>

            <Button variant="outline-light" onClick={handleContactClick}>
              SEND US A QUERY
            </Button>

            <div className="navbar-icons">
              <OverlayTrigger placement="bottom" overlay={<Tooltip>Call: 061 454 4633</Tooltip>}>
                <i className="bi bi-telephone contact-icon"></i>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={<Tooltip>Email: admin@highlandscollege.co.za</Tooltip>}>
                <i className="bi bi-envelope-at contact-icon"></i>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={<Tooltip>WhatsApp: 061 545 4633</Tooltip>}>
                <i className="bi bi-whatsapp contact-icon"></i>
              </OverlayTrigger>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Cover Image */}
      <img
        src={scienceImage}
        alt="Science Cover Page"
        className="img-fluid w-100"
        style={{
          maxHeight: '600px',
          objectFit: 'cover 50%',
          objectPosition: 'center 50%',
          marginTop: '-40px',
        }}
      />

      {/* Main Content */}
      <div className="main-home-content text-center mt-4">
        <h1 className="text-darkblue">WE NURTURE KNOWLEDGE</h1>
        <p className="text-darkblue">From first day to matric – we grow champions of life!</p>
      </div>

      {/* About Highlands Section */}
      <div className="container mt-5 mb-5">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <p className="fs-5 text-white">
              At Highlands School, we’re not just about books. We blend academic excellence, a passion for sports, and strong moral values – all in a warm, family-first environment.
            </p>
            <p className="fs-5 text-white">
              From the curious minds in Primary to the confident Matrics stepping into the world, our learners are supported every step of the way. We believe in balance, belonging, and building bright futures – with a smile!
            </p>
            <p className="fs-5 text-white fw-bold text-center">
              Come visit Highlands – your child’s second home starts here.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-5 mb-5">
        <h2 className="text-center mb-4">Why Choose Highlands?</h2>
        <div className="row">
          <div className="col-md-4 text-center">
            <i className="bi bi-book" style={{ fontSize: '2rem' }}></i>
            <h5 className="mt-2">Smart & Strong</h5>
            <p>Top-notch academics and sport – because your child can have both.</p>
          </div>
          <div className="col-md-4 text-center">
            <i className="bi bi-people" style={{ fontSize: '2rem' }}></i>
            <h5 className="mt-2">Heart-Led Teaching</h5>
            <p>We teach values, empathy and confidence – not just curriculum.</p>
          </div>
          <div className="col-md-4 text-center">
            <i className="bi bi-house-heart" style={{ fontSize: '2rem' }}></i>
            <h5 className="mt-2">Family First</h5>
            <p>A nurturing environment where every child feels seen, safe and supported.</p>
          </div>
        </div>
      </div>

      {/* Three Side-by-Side Images */}
      <div className="container mb-5">
        <div className="row">
          {[primary, primaryS, high].map((img, index) => (
            <div key={index} className="col-md-4 mb-3 d-flex justify-content-center">
              <img
                src={img}
                alt={`School ${index}`}
                className="img-fluid rounded shadow"
                style={{
                  width: '100%',
                  height: '250px',
                  objectFit: 'cover',
                  borderRadius: '10px',
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <MainHomeNav />
    </div>
  );
};

export default MainHome;
